/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Contactofficegraphic01/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Contactofficegraphic01({
  children,
  viewPath = "/DesignSystem/Svgs/Contactofficegraphic01",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 1128.3,
  height = 786.8,
  fill = "#DFF0E8",
  fill2 = "#404040",
  fill3 = "#F0F0F0",
  fill4 = "#8D575F",
  fill5 = "#2B2B2B",
  fill7 = "#009AEC",
  fill8 = "#007CD2",
  fill10 = "#9E616A",
  fill14 = "#333",
  fill15 = "#59636B",
  fill17 = "#292929",
  fill18 = "#DFDCE3",
  fill19 = "#CAC8CF",
  fill20 = "#65617D",
  fill21 = "#D7D4DD",
  fill24 = "#555169",
  fill27 = "#00BA70",
  fill33 = "#009E5F",
  fill53 = "#64BCEC",
  fill54 = "#EEE",
  fill55 = "#C7C7C7",
  fill56 = "#CFCFCF",
  fill57 = "#DCDCDC",
  fill58 = "#BBB",
  fill59 = "#C8E6D7",
  fill60 = "#FFF",
  fill62 = "none",
  stroke = "#FFF",
  stroke3 = "#9EDBC3"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Contactofficegraphic01.Svg"
  data-view-path={viewPath}
 viewBox="0 0 1128.3 786.8"
 style={{'--as-1-wWp3j': alignSelf,'--mt-2-wWp3j': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-wWp3j': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-wWp3j': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-wWp3j': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-wWp3j': opacity,'--w-7-wWp3j': typeof width === 'number' ? `${width}px` : width,'--h-8-wWp3j': typeof height === 'number' ? `${height}px` : height}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Contactofficegraphic01.SvgPath"
  data-view-path={viewPath}
 d="M406.2 91C215.5 150.8 62 386.2 31.9 493.2S55.8 653.8 109.5 689s237.9 67.7 496.4 33.6c60.4-2 315.5-8.1 375-18.5 33.1-5.7 67.2-14.9 91.2-37 30.5-28 38-75.4 17.6-110.6-34.3-58.9-128.8-73.5-152.8-136.7-13.2-34.7.3-73.5 19.5-105.8 41-69.3 55-198.5-96.3-251.1C731.3 18.1 592.5 32.6 406.2 91z"
 style={{'--f-9-wWp3j': fill}}
 className={`views-block ${styles.SvgPath}`}
/>
<path
  data-testid="Contactofficegraphic01.SvgPath:1"
  data-view-path={viewPath}
 d="M504.5 622.2s-1.8 12.1 1.1 19.6c2.9 7.5 14.5 32.1-1.1 32.1s-27.8 3.9-27.8-1.3c0 0-3.4-4.5-2.3-12.4 1.8-12.8 2.3-34.4 2.3-34.4l27.8-3.6z"
 style={{'--f-9-wWp3j': fill2}}
 className={`views-block ${styles.SvgPath1}`}
/>
<path
  data-testid="Contactofficegraphic01.SvgPath:2"
  data-view-path={viewPath}
 d="M379.1 181.4h1.6v15h-1.6zM480.8 218h1.6v15h-1.6zM493 471h1.6v15H493z"
 style={{'--f-9-wWp3j': fill3}}
 className={`views-block ${styles.SvgPath2}`}
/>
<path
  data-testid="Contactofficegraphic01.SvgPath:3"
  data-view-path={viewPath}
 d="M389 139.1s11.9 33.8 4.6 39.1c-7.3 5.2 24.7 47.7 24.7 47.7l38.4-10.4-21-35.6s-2.7-35.6-2.7-40.8c-.1-5.2-44 0-44 0z"
 style={{'--f-9-wWp3j': fill4}}
 className={`views-block ${styles.SvgPath3}`}
/>
<path
  data-testid="Contactofficegraphic01.SvgPath:4"
  data-view-path={viewPath}
 d="M369 380.4s-3.5 43.4 0 66 8.7 85 8.7 85 0 118 19.1 119.8c19.1 1.7 33 3.5 34.7-3.5 1.7-6.9-8.7-10.4-3.5-13.9 5.2-3.5 6.9-15.6 0-29.5s0-154.5 0-154.5l33 88.5s5.3 50.9 8.8 61.3c3.5 10.4-3.5 35 8.7 36.7 12.1 1.7 23.8-2.1 30.8-5.6 6.9-3.5-5.3-7.4-1.8-9.2 3.5-1.7 11-9.5 7.5-11.3-3.5-1.7-8.8-68.6-8.8-68.6s-9.5-177.9-21.7-184.8-20 5-20 5L369 380.4z"
 style={{'--f-9-wWp3j': fill5}}
 className={`views-block ${styles.SvgPath4}`}
/>
<path
  data-testid="Contactofficegraphic01.SvgPath:5"
  data-view-path={viewPath}
 d="M400.3 644.2v13.9s-15.6 37.7 0 37.7 27.8 3.9 27.8-1.3v-46.9l-27.8-3.4z"
 style={{'--f-9-wWp3j': fill5}}
 className={`views-block ${styles.SvgPath5}`}
/>
<path
  data-testid="Contactofficegraphic01.SvgPath:6"
  data-view-path={viewPath}
 d="M403.8 191.2s8.7 26 22.6 20.8l13.9-5.2 24.3 166.6s-19.1 27.8-46.9 10.4c-27.8-17.3-13.9-192.6-13.9-192.6z"
 style={{'--f-9-wWp3j': fill7}}
 className={`views-block ${styles.SvgPath6}`}
/>
<path
  data-testid="Contactofficegraphic01.SvgPath:7"
  data-view-path={viewPath}
 d="M428.1 186l7.8-16.5s46 21.7 52.9 28.6 6.9 17.4 6.9 17.4l-12.1 43.4s3.5 95.5 3.5 98.9c0 3.5 12.1 22.6 3.5 15.6s-10.4-13.9-17.4-3.5c-6.9 10.4-22.6 22.6-22.6 22.6L428.1 186zM412.4 180.8s-14.1-13.8-19.2-13c-5.1.8-12 13-12 13s-41.7 13.9-39.9 27.8c1.7 13.9 20.8 81.6 20.8 81.6s15.6 81.6 1.7 90.3 66 31.2 67.7 20.8c1.7-10.4 5.2-114.6 0-130.2-5.2-15.7-19.1-90.3-19.1-90.3z"
 style={{'--f-9-wWp3j': fill8}}
 className={`views-block ${styles.SvgPath7}`}
/>
<path
  data-testid="Contactofficegraphic01.SvgPath:8"
  data-view-path={viewPath}
 d="M472.5 371.9h-82.2c-8-36.9-8.7-72.5 0-106.6h82.2c-13.3 33.4-14.1 68.8 0 106.6z"
 style={{'--f-9-wWp3j': fill3}}
 className={`views-block ${styles.SvgPath8}`}
/>
<path
  data-testid="Contactofficegraphic01.SvgPath:9"
  data-view-path={viewPath}
 d="M356.9 326.6l24.3 10.4s46.9 6.9 46.9-12.1-46.9-8.7-46.9-8.7l-15.6-5-8.7 15.4z"
 style={{'--f-9-wWp3j': fill10}}
 className={`views-block ${styles.SvgPath9}`}
/>
<path
  data-testid="Contactofficegraphic01.SvgPath:10"
  data-view-path={viewPath}
 d="M362.1 198.1l-20.8 5.2-15.6 92s-5.2 24.3 3.5 26 33 15.6 33 15.6 3.5-26 10.4-26L355.2 297l10.4-60.7-3.5-38.2z"
 style={{'--f-9-wWp3j': fill8}}
 className={`views-block ${styles.SvgPath10}`}
/>
<path
  data-testid="Contactofficegraphic01.SvgPath:11"
  data-view-path={viewPath}
 d="M476.3 218.5l-6.7-43.6s-29.3-23.7-23.1-25.6 9.6 4.3 9.6 4.3-11.5-38.8-.6-26c4.8 5.6 8.9 12.8 17.6 20.5 10.2 9.1 24.8 64.7 24.8 64.7l-21.6 5.7z"
 style={{'--f-9-wWp3j': fill10}}
 className={`views-block ${styles.SvgPath11}`}
/>
<path
  data-testid="Contactofficegraphic01.SvgPath:12"
  data-view-path={viewPath}
 d="M480.7 274.7l19.2-4.1s5.5-40 6.2-44.2c.7-4.2-.1-23.5-1.7-23.2-1.6.3-31.7 10.8-32.4 7.9l8.7 63.6z"
 style={{'--f-9-wWp3j': fill8}}
 className={`views-block ${styles.SvgPath12}`}
/>
<path
  data-testid="Contactofficegraphic01.SvgPath:13"
  data-view-path={viewPath}
 d="M467 153.9l-10.5 3.3c-.4.1-.9-.4-1.1-1l-9.8-22.7c-.2-.5-.2-1.1.1-1.4l8-10.2c.3-.4.7-.2 1 .5l12.5 29.8c.1.8.1 1.5-.2 1.7z"
 style={{'--f-9-wWp3j': fill14}}
 className={`views-block ${styles.SvgPath13}`}
/>
<path
  data-testid="Contactofficegraphic01.SvgPath:14"
  data-view-path={viewPath}
 d="M466.2 150.2l-11.5 4.5-8.9-20.4 9.2-10.9z"
 style={{'--f-9-wWp3j': fill15}}
 className={`views-block ${styles.SvgPath14}`}
/>
<circle
  data-testid="Contactofficegraphic01.SvgCircle"
  data-view-path={viewPath}
 cx={418.8}
 cy={133}
 r={31.2}
 style={{'--f-9-wWp3j': fill10}}
 className={`views-block ${styles.SvgCircle}`}
/>
<path
  data-testid="Contactofficegraphic01.SvgPath:15"
  data-view-path={viewPath}
 d="M393 93.8c1 1.1 2.3 1.8 3.7 2l-5.6.5c0 1.2.4 2.4 1.2 3.3-6.8 0-12.3 6.4-13.5 13.2-1.2 6.7.8 13.6 3.1 20 1 2.7 3.7 6.1 6 4.4 0-2.4.1-4.8 1.2-6.9 1.1-2.1 3.6-3.6 5.8-2.9-1.1-5 3-9.9 7.9-11.6 4.8-1.7 10.1-.9 15.2-.1 5.5.9 11.2 1.9 15.7 5.1 8.9 6.4 10.1 19 10.4 30 .7-5 6.6-8.5 11.4-6.8l-2.9-9.5c-.3-1.1.9-2.8 1.3-1.7-1.1-2.3-1.7-4.8-1.7-7.3l2.6 1c2.3-9.5-3-19.2-9.1-26.8-2.1-2.8-4.6-5.3-7.4-7.3-6.2-4-14.1-3.8-21.5-3.6-3.8.2-21.5 7.5-23.8 5z"
 style={{'--f-9-wWp3j': fill17}}
 className={`views-block ${styles.SvgPath15}`}
/>
<g
  data-testid="Contactofficegraphic01.SvgGroup"
  data-view-path={viewPath}
 className="views-block"
>
<path
  data-testid="Contactofficegraphic01.SvgPath:16"
  data-view-path={viewPath}
 d="M394.9 750.8s51.7-2.8 64.2-10.2 30.4-7.4 30.5-7.4l183.5-31 85.5-20.3 15.3-2-50.4-57.6-1.5-.7s19.7 14.3-35.1 9.4c-43.4-3.9-35.7 37.5-72.4 48.9-31.2 9.7-32 9.5-72.3 11.3-31.8 1.4-54.3-28.5-104.4-5.5-26.8 12.4-42.9 65.1-42.9 65.1z"
 style={{'--f-9-wWp3j': fill18}}
 className={`views-block ${styles.SvgPath16}`}
/>
<path
  data-testid="Contactofficegraphic01.SvgPath:17"
  data-view-path={viewPath}
 d="M659.9 691c.6 2.5.4 4.9-.9 6.7-2.8 2.8-21.8 5.2-25.1 7.3l130.8-25.1-1.8-17.2-74.3-32.1s-20-2.5-32 10.1c-14 14.5-7.5 31.7-3.5 37.1 2.5 3.7 5.8 8.7 6.8 13.2z"
 style={{'--f-9-wWp3j': fill19}}
 className={`views-block ${styles.SvgPath17}`}
/>
<path
  data-testid="Contactofficegraphic01.SvgPath:18"
  data-view-path={viewPath}
 d="M771.1 437.9l-84.1 4.6V631l77.7 44.5 29.1-26.8-6-88.8 6-82.7z"
 style={{'--f-9-wWp3j': fill20}}
 className={`views-block ${styles.SvgPath18}`}
/>
<path
  data-testid="Contactofficegraphic01.SvgPath:19"
  data-view-path={viewPath}
 d="M843.7 412.9l-114.4-30.7c-2.7-.8-235.3 2.3-334.5 11.8s-143.2 84.5-157.3 121.5c-14.1 37-12.2 79.2-8.5 107.6 3.7 28.4 15.6 50.5 15.6 50.5s-23.6-220.9 211.7-232l387.4-28.7z"
 style={{'--f-9-wWp3j': fill21}}
 className={`views-block ${styles.SvgPath19}`}
/>
<path
  data-testid="Contactofficegraphic01.SvgPath:20"
  data-view-path={viewPath}
 d="M260.9 647.7l17.6 59.6 39.7 38.8 49.9 10.2 77.6-13.9V466.6s-13.4-8.8-14.8-8.8-38.8 6-38.8 6l-84.8 60.8-3.5 2.5-37.8 56.4-5.1 64.2z"
 style={{'--f-9-wWp3j': fill20}}
 className={`views-block ${styles.SvgPath20}`}
/>
<path
  data-testid="Contactofficegraphic01.SvgPath:21"
  data-view-path={viewPath}
 d="M445.7 455v287.5l-7.5 1.3V455z"
 style={{'--f-9-wWp3j': fill20}}
 className={`views-block ${styles.SvgPath21}`}
/>
<path
  data-testid="Contactofficegraphic01.SvgPath:22"
  data-view-path={viewPath}
 d="M771.1 437.9l-84.1 4.6V631l77.7 44.5 29.1-26.8-6-88.8 6-82.7zM445.7 455v287.5l-7.5 1.3V455z"
 style={{'--f-9-wWp3j': fill24}}
 className={`views-block ${styles.SvgPath22}`}
/>
<path
  data-testid="Contactofficegraphic01.SvgPath:23"
  data-view-path={viewPath}
 d="M305.7 543.8c55.5-45.6 117.1-52.3 140-53.1v-24.1s-13.4-8.8-14.8-8.8-38.8 6-38.8 6l-84.8 60.8-1.6 19.2z"
 style={{'--f-9-wWp3j': fill24}}
 className={`views-block ${styles.SvgPath23}`}
/>
<path
  data-testid="Contactofficegraphic01.SvgPath:24"
  data-view-path={viewPath}
 d="M900.1 533.1s-5.7 15.1-11.9 32.7c-5.4 15.6-11.2 33.3-13.6 44-.9 4.1-3.2 8.3-6.5 12.5-15 19-49.5 37.4-55.4 43.9-7.3 8-48.1 13.7-48.1 13.7V434.7l27.3-8.8h34.7l44.8 20.3 23.1 34.2 5.6 52.7z"
 style={{'--f-9-wWp3j': fill20}}
 className={`views-block ${styles.SvgPath24}`}
/>
<path
  data-testid="Contactofficegraphic01.SvgPath:25"
  data-view-path={viewPath}
 d="M737.9 376.7s-3.2 14.7 10.9 16.5l.9-1.6c-.1-.1-11-10.3-11.8-14.9z"
 style={{'--f-9-wWp3j': fill27}}
 className={`views-block ${styles.SvgPath25}`}
/>
<path
  data-testid="Contactofficegraphic01.SvgPath:26"
  data-view-path={viewPath}
 d="M754.1 391.4l-3.3.7-.3.1s-8.7-7.1-8.6-22.9c1.2 2.3 2.6 4.5 4.2 6.6 3.4 4.6 7.4 10.7 8 15.5z"
 style={{'--f-9-wWp3j': fill27}}
 className={`views-block ${styles.SvgPath26}`}
/>
<path
  data-testid="Contactofficegraphic01.SvgPath:27"
  data-view-path={viewPath}
 d="M755.2 392.9c-.5.3-1.2.4-1.8.2-8.4-2-5.5-29.3-5.5-29.3.5.2 1 3.7 2.9 8.2 3.4 7.9 7.1 19 4.4 20.9zM773.9 376.7s.5 14.7-13.5 16.5l-.9-1.6c0-.1 13.4-10.3 14.4-14.9z"
 style={{'--f-9-wWp3j': fill27}}
 className={`views-block ${styles.SvgPath27}`}
/>
<path
  data-testid="Contactofficegraphic01.SvgPath:28"
  data-view-path={viewPath}
 d="M769.8 369.3c.1 15.8-11.2 22.9-11.2 22.9l-.3-.1-3.3-.7c.6-4.9 4.6-11 8-15.5 2-2.5 4.3-4.7 6.8-6.6z"
 style={{'--f-9-wWp3j': fill27}}
 className={`views-block ${styles.SvgPath28}`}
/>
<path
  data-testid="Contactofficegraphic01.SvgPath:29"
  data-view-path={viewPath}
 d="M758.2 391.5c-.5.6-1.1 1.1-1.8 1.4-.2.1-.5.2-.7.2-2.1.5-2.8-1-2.7-3.5.2-4.5 3-12.3 5.5-18.2 1.2-2.9 3-5.5 5.3-7.6 0 .1-.1 21.4-5.6 27.7z"
 style={{'--f-9-wWp3j': fill27}}
 className={`views-block ${styles.SvgPath29}`}
/>
<path
  data-testid="Contactofficegraphic01.SvgPath:30"
  data-view-path={viewPath}
 d="M755.9 354.3s-9.4 33.3-1.3 38.3c8 4.9 3.3-35.4 1.3-38.3z"
 style={{'--f-9-wWp3j': fill27}}
 className={`views-block ${styles.SvgPath30}`}
/>
<path
  data-testid="Contactofficegraphic01.SvgPath:31"
  data-view-path={viewPath}
 d="M737.9 376.7s-3.2 14.7 10.9 16.5l.9-1.6c-.1-.1-11-10.3-11.8-14.9z"
 style={{'--f-9-wWp3j': fill33}}
 className={`views-block ${styles.SvgPath31}`}
/>
<path
  data-testid="Contactofficegraphic01.SvgPath:32"
  data-view-path={viewPath}
 d="M754.1 391.4l-3.3.7-.3.1s-8.7-7.1-8.6-22.9c1.2 2.3 2.6 4.5 4.2 6.6 3.4 4.6 7.4 10.7 8 15.5z"
 style={{'--f-9-wWp3j': fill33}}
 className={`views-block ${styles.SvgPath32}`}
/>
<path
  data-testid="Contactofficegraphic01.SvgPath:33"
  data-view-path={viewPath}
 d="M755.2 392.9c-.5.3-1.2.4-1.8.2-8.4-2-5.5-29.3-5.5-29.3.5.2 1 3.7 2.9 8.2 3.4 7.9 7.1 19 4.4 20.9zM773.9 376.7s.5 14.7-13.5 16.5l-.9-1.6c0-.1 13.4-10.3 14.4-14.9z"
 style={{'--f-9-wWp3j': fill33}}
 className={`views-block ${styles.SvgPath33}`}
/>
<path
  data-testid="Contactofficegraphic01.SvgPath:34"
  data-view-path={viewPath}
 d="M769.8 369.3c.1 15.8-11.2 22.9-11.2 22.9l-.3-.1-3.3-.7c.6-4.9 4.6-11 8-15.5 2-2.5 4.3-4.7 6.8-6.6z"
 style={{'--f-9-wWp3j': fill33}}
 className={`views-block ${styles.SvgPath34}`}
/>
<path
  data-testid="Contactofficegraphic01.SvgPath:35"
  data-view-path={viewPath}
 d="M758.2 391.5c-.5.6-1.1 1.1-1.8 1.4-.2.1-.5.2-.7.2-2.1.5-2.8-1-2.7-3.5.2-4.5 3-12.3 5.5-18.2 1.2-2.9 3-5.5 5.3-7.6 0 .1-.1 21.4-5.6 27.7z"
 style={{'--f-9-wWp3j': fill33}}
 className={`views-block ${styles.SvgPath35}`}
/>
<path
  data-testid="Contactofficegraphic01.SvgPath:36"
  data-view-path={viewPath}
 d="M755.9 354.3s-9.4 33.3-1.3 38.3c8 4.9 3.3-35.4 1.3-38.3z"
 style={{'--f-9-wWp3j': fill33}}
 className={`views-block ${styles.SvgPath36}`}
/>
<path
  data-testid="Contactofficegraphic01.SvgPath:37"
  data-view-path={viewPath}
 d="M737.9 376.7s-1.8 14.7 12.2 16.5l.9-1.6c0-.1-12.3-10.3-13.1-14.9z"
 style={{'--f-9-wWp3j': fill27}}
 className={`views-block ${styles.SvgPath37}`}
/>
<path
  data-testid="Contactofficegraphic01.SvgPath:38"
  data-view-path={viewPath}
 d="M755.4 391.4l-3.3.7-.3.1s-10-7.1-9.9-22.9c0 0 2.6 2.8 5.5 6.6 3.4 4.6 7.4 10.7 8 15.5z"
 style={{'--f-9-wWp3j': fill27}}
 className={`views-block ${styles.SvgPath38}`}
/>
<path
  data-testid="Contactofficegraphic01.SvgPath:39"
  data-view-path={viewPath}
 d="M755.4 391.4l-3.3.7c-3.1-2.7-4.3-9.8-4.8-16.2 3.5 4.6 7.5 10.7 8.1 15.5z"
 style={{'--f-9-wWp3j': fill33}}
 className={`views-block ${styles.SvgPath39}`}
/>
<path
  data-testid="Contactofficegraphic01.SvgPath:40"
  data-view-path={viewPath}
 d="M756.5 392.9c-.5.3-1.2.4-1.8.2-8.4-2-6.9-29.3-6.9-29.3.5.2 2.3 3.7 4.2 8.2 3.5 7.9 7.2 19 4.5 20.9zM773.9 376.7s1.8 14.7-12.2 16.5l-.9-1.6c0-.1 12.1-10.3 13.1-14.9z"
 style={{'--f-9-wWp3j': fill27}}
 className={`views-block ${styles.SvgPath40}`}
/>
<path
  data-testid="Contactofficegraphic01.SvgPath:41"
  data-view-path={viewPath}
 d="M769.8 369.3c.1 15.8-9.9 22.9-9.9 22.9l-.3-.1-3.3-.7c.6-4.9 4.6-11 8-15.5 2.9-3.8 5.5-6.6 5.5-6.6z"
 style={{'--f-9-wWp3j': fill27}}
 className={`views-block ${styles.SvgPath41}`}
/>
<path
  data-testid="Contactofficegraphic01.SvgPath:42"
  data-view-path={viewPath}
 d="M764.3 375.9c-.4 6-1.5 12.5-4.2 15.6l-.6.6-3.3-.7c.7-4.8 4.7-10.9 8.1-15.5z"
 style={{'--f-9-wWp3j': fill33}}
 className={`views-block ${styles.SvgPath42}`}
/>
<path
  data-testid="Contactofficegraphic01.SvgPath:43"
  data-view-path={viewPath}
 d="M759.5 391.5c-.5.6-1.1 1.1-1.8 1.4-.2.1-.4.2-.7.2-2.1.5-2.8-1-2.7-3.5.2-4.5 3-12.3 5.5-18.2 1.8-4.2 3.5-7.4 4-7.6 0 .1 1.2 21.4-4.3 27.7z"
 style={{'--f-9-wWp3j': fill27}}
 className={`views-block ${styles.SvgPath43}`}
/>
<path
  data-testid="Contactofficegraphic01.SvgPath:44"
  data-view-path={viewPath}
 d="M756.5 392.9c-.5 0-.9-.2-1.3-.4-3.9-2.5-4-11.7-3.1-20.5 3.4 7.9 7.1 19 4.4 20.9z"
 style={{'--f-9-wWp3j': fill33}}
 className={`views-block ${styles.SvgPath44}`}
/>
<path
  data-testid="Contactofficegraphic01.SvgPath:45"
  data-view-path={viewPath}
 d="M759.5 391.5c-.5 1-1.1 1.5-1.8 1.4-.4-.1-.8-.2-1.1-.4-1-.7-1.8-1.7-2.2-2.9.2-4.5 3-12.3 5.5-18.2.9 8.2 1.2 16.8-.4 20.1z"
 style={{'--f-9-wWp3j': fill33}}
 className={`views-block ${styles.SvgPath45}`}
/>
<path
  data-testid="Contactofficegraphic01.SvgPath:46"
  data-view-path={viewPath}
 d="M755.9 354.3s-8.1 33.3 0 38.3c8 4.9 2-35.4 0-38.3z"
 style={{'--f-9-wWp3j': fill27}}
 className={`views-block ${styles.SvgPath46}`}
/>
<path
  data-testid="Contactofficegraphic01.SvgPath:47"
  data-view-path={viewPath}
 d="M768.5 394.2l-.6 2.9-2 10.8h-19.5l-2.1-10.8-.5-2.9z"
 style={{'--f-9-wWp3j': fill20}}
 className={`views-block ${styles.SvgPath47}`}
/>
<path
  data-testid="Contactofficegraphic01.SvgPath:48"
  data-view-path={viewPath}
 d="M739.1 390.9h33.6v5.6h-33.6z"
 style={{'--f-9-wWp3j': fill20}}
 className={`views-block ${styles.SvgPath48}`}
/>
<path
  data-testid="Contactofficegraphic01.SvgPath:49"
  data-view-path={viewPath}
 d="M829.4 437.9s56.8 45.8 47.9 114.1c-5.5 42.1-17.6 94.8-112.6 123.4v6.5l40.3-11.2 27.4-15.1 20.9-18.8 25.5-31.2 11.9-25.4 4.3-33.5 2.5-38.2-6.1-32.7-14.4-21.3-17.6-13.7-30-2.9z"
 style={{'--f-9-wWp3j': fill21}}
 className={`views-block ${styles.SvgPath49}`}
/>
<path
  data-testid="Contactofficegraphic01.SvgPath:50"
  data-view-path={viewPath}
 d="M240.2 602.6c-6.3 33.3-1.4 67.9 15 97.6 47.7 86.5 149.1 61.1 179 51.3 7.1-2.3 14.3-4.4 21.6-6l307.3-60.8C876.5 664.8 899.9 573 899.9 573c22.5-70.8 7.1-112.1-13.3-135.5-16.3-18.5-40.2-28.6-64.9-27.1l-39.1 2.1-325.3 24C295 438.3 251.7 541.7 240.2 602.6zm32.2 4.1c11-52.4 53.9-128.3 192.1-133 6.3-.2 12.7-.8 19-1.6L772 444.5l36-1.8c27-1.4 53.1 11.2 68.1 33.7 14.3 21.5 22 55.5 4.3 108.2 0 0-21.7 80.2-126.5 97.4l-282.2 51.3c-6.9 1.5-13.8 3.3-20.5 5.4-27.6 8.5-119.4 30.1-164-42.4-16.3-26.8-21.2-58.9-14.8-89.6z"
 style={{'--f-9-wWp3j': fill18}}
 className={`views-block ${styles.SvgPath50}`}
/>
</g>
<path
  data-testid="Contactofficegraphic01.SvgPath:51"
  data-view-path={viewPath}
 d="M444.984 221.461l20.026-1.719.47 5.48-20.025 1.719z"
 style={{'--f-9-wWp3j': fill53}}
 className={`views-block ${styles.SvgPath51}`}
/>
<path
  data-testid="Contactofficegraphic01.SvgPath:52"
  data-view-path={viewPath}
 d="M608.1 387l-114.4 5.7-21.1-5.5 114.3-5.7z"
 style={{'--f-9-wWp3j': fill54}}
 className={`views-block ${styles.SvgPath52}`}
/>
<path
  data-testid="Contactofficegraphic01.SvgPath:53"
  data-view-path={viewPath}
 d="M472.6 387.2v1.9l21.1 9.1 114.4-5.5v-5.5l-114.4 5.5z"
 style={{'--f-9-wWp3j': fill55}}
 className={`views-block ${styles.SvgPath53}`}
/>
<path
  data-testid="Contactofficegraphic01.SvgPath:54"
  data-view-path={viewPath}
 d="M642.9 368.9L458 378.8l25.6-141.7 184.9 7.5s-1.2 38.8-7.3 67.6-18.3 56.7-18.3 56.7z"
 style={{'--f-9-wWp3j': fill56}}
 className={`views-block ${styles.SvgPath54}`}
/>
<path
  data-testid="Contactofficegraphic01.SvgPath:55"
  data-view-path={viewPath}
 d="M587.8 405.4l-37.4 2v-80.1h37.4z"
 style={{'--f-9-wWp3j': fill57}}
 className={`views-block ${styles.SvgPath55}`}
/>
<path
  data-testid="Contactofficegraphic01.SvgPath:56"
  data-view-path={viewPath}
 d="M458 378.1s14.4-33 20.1-65.9c7.3-42.1 5.5-75.1 5.5-75.1"
 style={{'--f-9-wWp3j': fill58}}
 className={`views-block ${styles.SvgPath56}`}
/>
<g
  data-testid="Contactofficegraphic01.SvgGroup:1"
  data-view-path={viewPath}
 className="views-block"
>
<path
  data-testid="Contactofficegraphic01.SvgPath:57"
  data-view-path={viewPath}
 d="M686.6 147.4H487.5c9.5-1.7 10.8-4.9 10.8-10.9V74.7c0-6 4.9-10.9 10.9-10.9h177.4c6 0 10.9 4.9 10.9 10.9v61.7c.1 6.1-4.8 11-10.9 11z"
 style={{'--f-9-wWp3j': fill59}}
 className={`views-block ${styles.SvgPath57}`}
/>
<path
  data-testid="Contactofficegraphic01.SvgPath:58"
  data-view-path={viewPath}
 d="M683 143.7H483.8c9.5-1.7 10.8-4.9 10.8-10.9V71c0-6 4.9-10.9 10.9-10.9H683c6 0 10.9 4.9 10.9 10.9v61.7c0 6.1-4.9 11-10.9 11z"
 style={{'--f-9-wWp3j': fill60}}
 className={`views-block ${styles.SvgPath58}`}
/>
<circle
  data-testid="Contactofficegraphic01.SvgCircle:1"
  data-view-path={viewPath}
 cx={540.5}
 cy={102.9}
 r={23.8}
 style={{'--f-9-wWp3j': fill27}}
 className={`views-block ${styles.SvgCircle1}`}
/>
<path
  data-testid="Contactofficegraphic01.SvgPath:59"
  data-view-path={viewPath}
 strokeWidth={4}
 strokeMiterlimit={10}
 d="M553.8 93.4L536 111.1l-8.8-8.9"
 style={{'--f-9-wWp3j': fill62,'--s-10-wWp3j': stroke}}
 className={`views-block ${styles.SvgPath59}`}
/>
<circle
  data-testid="Contactofficegraphic01.SvgCircle:2"
  data-view-path={viewPath}
 cx={595.5}
 cy={102.9}
 r={23.8}
 style={{'--f-9-wWp3j': fill27}}
 className={`views-block ${styles.SvgCircle2}`}
/>
<path
  data-testid="Contactofficegraphic01.SvgPath:60"
  data-view-path={viewPath}
 strokeWidth={4}
 strokeMiterlimit={10}
 d="M608.8 93.4L591 111.1l-8.8-8.9"
 style={{'--f-9-wWp3j': fill62,'--s-10-wWp3j': stroke}}
 className={`views-block ${styles.SvgPath60}`}
/>
<circle
  data-testid="Contactofficegraphic01.SvgCircle:3"
  data-view-path={viewPath}
 strokeWidth={3}
 strokeMiterlimit={10}
 cx={650.3}
 cy={102.9}
 r={23.8}
 style={{'--f-9-wWp3j': fill62,'--s-10-wWp3j': stroke3}}
 className={`views-block ${styles.SvgCircle3}`}
/>
<path
  data-testid="Contactofficegraphic01.SvgPath:61"
  data-view-path={viewPath}
 strokeWidth={3}
 strokeMiterlimit={10}
 d="M663.6 93.4l-17.7 17.7-8.9-8.9"
 style={{'--f-9-wWp3j': fill62,'--s-10-wWp3j': stroke3}}
 className={`views-block ${styles.SvgPath61}`}
/>
</g>
</svg>
{children}
</React.Fragment>)
}